import { useAction } from '@reatom/npm-react'
import styled from 'styled-components'

import { Avatar } from '@blade/ui-kit'
import { unsafeUrlDialogEvent } from '@root/entities/deeplinking/unsafe-url-dialog'
import { ImagePopover } from '@root/shared/ui'

import type { WikiPageSummary } from '../model/wiki-page-summary'

export const SocialWikiSummary = ({
  url,
  summary,
}: {
  url: string
  summary: WikiPageSummary
}) => {
  const imageURL = summary.thumbnail?.source

  const openUnsafeUrlDialog = useAction(unsafeUrlDialogEvent)

  const handleOpenResource = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()

    openUnsafeUrlDialog([url, 'wiki'])
  }

  return (
    <Root>
      <Image href={url} onClick={handleOpenResource}>
        {imageURL ? (
          <ImagePopover src={imageURL.toString()} alt={summary.title || ''}>
            <Avatar
              src={imageURL.toString()}
              alt={summary.title || ''}
              size={96}
            />
          </ImagePopover>
        ) : undefined}
      </Image>

      <Text>
        <ExternalLinkRoot href={url} onClick={handleOpenResource}>
          {summary.title || url}
        </ExternalLinkRoot>
        {summary.description ? (
          <SubTitle>{summary.description}</SubTitle>
        ) : undefined}
        {summary.extract ? (
          <Description>{summary.extract}</Description>
        ) : undefined}
      </Text>
    </Root>
  )
}

const Root = styled.div`
  display: flow-root;
  padding: 10px;
  background: var(--background-1);
`
const Text = styled.div`
  & * + * {
    margin-top: 4px;
  }
`
const SubTitle = styled.p`
  color: var(--text-11);
  font-size: 16px;
  font-weight: 400;
`
const Description = styled.p`
  color: var(--text-9);
  font-weight: 400;
  font-size: 15px;
`

const Image = styled.a`
  margin: 0 8px 0 0;
  float: left;
`

const ExternalLinkRoot = styled.a`
  color: var(--text-12);

  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
